import { globalStyles } from 'styles/theme';
import styled from '@emotion/styled';

export default styled.span({
  color: globalStyles.colors.white,
});
